"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const _util_1 = require("../_util");
const DateTime = (props) => {
    const { value, start, format = 'yyyy-MM-dd', placeholder, onChange, onOpen, onComplete } = props;
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        const [err, res] = yield _util_1.to(_util_1.sync(one_2.datePicker, {
            format,
            currentDate: start ? start : dayjs_1.default().format(format),
            complete: onComplete,
        }));
        if (err) {
            one_2.showToast({
                type: 'none',
                content: '调用datePicker失败',
                duration: 2000,
            });
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(res.date);
    });
    return (React.createElement(one_1.View, { style: {
            height: '42px',
        }, onTap: handleClick }, value ? value : placeholder));
};
exports.default = DateTime;
